<app-navbar></app-navbar>

<div class="register-page-wrapper">
  <div class="register-page-background"></div>
  <div class="register-page-content container">
    <div class="container">
      <div class="justify-content-center row">
        <div class="col-lg-5">
          <div class="login-card">
            <div class="bg-white pb-5 card-header">
              <div class="login-img">
                <div class="login-img_container">
                  <img src="assets/img/Main_Logo_Color.png" alt="kharaaj" />
                </div>
              </div>
            </div>
            <div class="mt-3 px-lg-5 py-lg-5 card-body">
              <div class="text-login text-muted text-right">
                <div class="text-login_welcome">مرحباً بك</div>
                <h1 class="mt-3 h3" itemprop="name">تسجيل الدخول إلى خراج</h1>
                <p class="text-muted">
                  أهلاً بك في أول منصة لبيع المنتجات الزراعية بالجملة
                </p>
              </div>

              <form

                class="login-form"
                role="form"
                [formGroup]="loginForm"
                (ngSubmit)="showPassword ? proceedWithLogin() : onSubmit()"
              >
                <!-- Account Selection for Multiple Accounts -->
                <div *ngIf="showAccountSelection" class="form-group mb-3 user-type-selection">
                  <label class="type-label">اختر نوع حسابك</label>
                  <div class="account-selection-grid" dir="rtl">
                    <button
                      type="button"
                      *ngFor="let account of availableAccounts"
                      class="account-option-btn"
                      (click)="selectAccount(account.type)"
                    >
                      <div class="account-details">
                        <div class="account-type">{{ getAccountTypeLabel(account.type) }}</div>
                        <div class="account-name" *ngIf="account.firstName">
                          {{ account.firstName }} {{ account.lastName }}
                        </div>
                      </div>
                    </button>
                  </div>
                </div>

                <div *ngIf="showPhoneInput" class="form-group mb-3">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text phone-code">{{
                        phoneCode
                      }}</span>
                    </div>
                    <!-- Replace the phone number input field with this updated version -->
                    <input
                      formControlName="phoneNumber"
                      class="form-control"
                      placeholder="إدخال رقم الهاتف"
                      pattern="[\d٠١٢٣٤٥٦٧٨٩]*"
                      [maxlength]="phoneLength"
                      type="tel"
                    />
                  </div>
                  <small
                    *ngIf="
                      loginForm.get('phoneNumber')?.errors?.required &&
                      loginForm.get('phoneNumber')?.touched
                    "
                    class="text-danger"
                  >
                    رقم الهاتف مطلوب
                  </small>
                </div>

                <div *ngIf="showPassword" class="form-group mb-3">
                  <div class="input-group input-group-alternative">
                    <input
                      formControlName="pwd"
                      class="form-control"
                      placeholder="كلمة المرور"
                      type="password"
                    />
                  </div>
                  <small
                    *ngIf="
                      loginForm.get('pwd')?.errors?.required &&
                      loginForm.get('pwd')?.touched
                    "
                    class="text-danger"
                  >
                    كلمة المرور مطلوبة
                  </small>
                  <br />
                  <a
                    routerLink="/auth/forget-password"
                    class="forgot-password-link"
                  >
                    نسيت كلمة السر؟
                  </a>
                </div>

                <div class="text-center login-form_bottom">
                  <button
                    *ngIf="!showAccountSelection"
                    type="submit"
                    class="my-4 btn btn-primary login-btn"
                    [disabled]="loginForm.invalid || isLoading"
                  >
                    <span *ngIf="!isLoading">{{
                      showPassword ? "تسجيل الدخول" : "التالي"
                    }}</span>
                    <span
                      *ngIf="isLoading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                  </button>

                  <!-- Add this reset button -->
                  <button
                    type="button"
                    class="my-4 btn-outline-secondary btn reset-btn"
                    (click)="resetForm()"
                    [disabled]="isLoading"
                  >
                    {{ showAccountSelection ? "رجوع" : "إعادة تعيين" }}
                  </button>

                  <div class="register-link">
                    <a
                      [routerLink]="APP_ROUTES.AUTH.REGISTER"
                      class="text-black c-pointer"
                    >
                      <small>ليس لديك حساب؟ سجل الآن</small>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
